import { FC } from 'react'
import { CommonRegulations, PhotoRegulations, NewsRegulations } from '../components';

export const agreementsMap: { [key: string]: FC } = {
    'OGÓLNA KLAUZULA INFORMACYJNA DLA CZŁONKÓW PTTK': CommonRegulations,
    'KLAUZULA ZGODY NA NEWSLETTER': NewsRegulations,
    'KLAUZULA ZGODY NA WYKORZYSTANIE WIZERUNKU': PhotoRegulations,
};

